(() => {
 function initialize(root) {
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized='true';
  const first=root.querySelector('[data-story-first-cta]');
  const final=root.querySelector('[data-story-final-cta]');
  const sticky=root.querySelector('[data-story-sticky]');
  if (!first || !final || !sticky || !('IntersectionObserver' in window)) return;
  let pastFirst=false, atFinal=false;
  const firstObserver=new IntersectionObserver(entries=>{pastFirst=entries[0].boundingClientRect.bottom<0;sticky.hidden=!pastFirst||atFinal;});
  const finalObserver=new IntersectionObserver(entries=>{atFinal=entries[0].isIntersecting;sticky.hidden=!pastFirst||atFinal;});
  firstObserver.observe(first);finalObserver.observe(final);
  root.addEventListener('gl:cleanup',()=>{firstObserver.disconnect();finalObserver.disconnect();},{once:true});
 }
 document.querySelectorAll('[data-gl-story]').forEach(initialize);
 document.addEventListener('shopify:section:load',event=>initialize(event.target.querySelector('[data-gl-story]')));
 document.addEventListener('shopify:section:unload',event=>event.target.querySelector('[data-gl-story]')?.dispatchEvent(new Event('gl:cleanup')));
})();